<script lang="ts" setup>
  import { computed } from 'vue';
  import {
    tabItemClass,
    tabItemSelectedClass,
    underlineBorderClass,
    underlineBorderSelectedClass,
    underlineBorderFirstItemClass,
    underlineBorderLastItemClass,
  } from './TabItem.css';

  type TabsItemProps = {
    name: string;
    label: string;
    selected?: boolean;
    isFirst?: boolean;
    isLast?: boolean;
    onClick: () => void;
  };

  const props = defineProps<TabsItemProps>();

  defineEmits<{
    click: [event?: Event];
  }>();

  const tabItemClasses = computed(() => [
    tabItemClass,
    { [tabItemSelectedClass]: props.selected },
  ]);

  const onActivate = () => {
    if (props.selected) return;
    props.onClick();
  };

  const underlineBorderClasses = computed(() => [
    underlineBorderClass,
    {
      [underlineBorderSelectedClass]: props.selected,
      [underlineBorderFirstItemClass]: props.isFirst,
      [underlineBorderLastItemClass]: props.isLast,
    },
  ]);
</script>

<template>
  <div
    :class="tabItemClasses"
    role="tab"
    :aria-selected="selected"
    :tabindex="selected ? 0 : -1"
    @click="onActivate"
    @keydown.enter="onActivate"
    @keydown.space.prevent="onActivate"
  >
    {{ label }}
    <div :class="underlineBorderClasses" />
  </div>
</template>
